import { io, type Socket } from 'socket.io-client';
import { env } from '@/lib/env';

let socket: Socket | null = null;
let currentToken: string | null = null;

/**
 * Return the singleton Socket.IO client.
 * A new socket is created ONLY when there is no existing socket,
 * or when the auth token has changed (login/logout).
 *
 * IMPORTANT: do NOT recreate the socket just because socket.connected is
 * false -- Socket.IO handles reconnection internally.  Recreating the socket
 * would orphan every handler registered by useGameSocket.
 */
export function getSocket(token: string): Socket {
  if (socket && currentToken === token) return socket;

  // Token changed (re-login) or no socket yet -- create fresh.
  if (socket) {
    socket.disconnect();
    socket = null;
  }

  currentToken = token;
  socket = io(env.VITE_SOCKET_URL || window.location.origin, {
    transports: ['websocket'],
    auth: { token },
    autoConnect: true,
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1_000,
    reconnectionDelayMax: 5_000,
  });

  return socket;
}

export function closeSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
  currentToken = null;
}

export function getCurrentSocket(): Socket | null {
  return socket;
}
